export default {
	cixiangweibitianxiang: 'Item ini diperlukan',
	dengluyihuode: 'Login untuk proses yang lebih sempit.',
	haimeiyouzhanghu: 'Belum punya rekening?',
	lijizhuce: 'Daftar sekarang',
	xuanzebeishiwei: 'Memilih pilihan, Anda dianggap telah setuju dengan',
	tiaokuan: 'Terma dan Kondisi',
	yinsishengming: 'Penjelasan Kepribadian',
	yiji: 'dan',
	huo: 'atau',
	dianziyoujian: 'Email',
	mima: 'Kata Sandi',
	dengru: 'Masuk',
	qudenglu: 'Silahkan Masuk',
	zhuce: 'Pendaftaran',
	zhucechenggong: 'Pendaftaran Berhasil',
	buyizhi: 'Tidak Teratur',
	meiyoushoudao: 'Apakah anda tidak menerima verifikasi melalui email?',
	yikerenshenfen: 'Lanjut sebagai tamu',
	wangjimima: 'Lupa Kata Sandi',
	zhanghao: 'Akun',
	yanzhengzhanghao: 'Verifikasi Akun',
	yanzhengmima: 'Verifikasi Kata Sandi',
	yanzhengdianziyoujian: 'Verifikasi Email',
	youketishi: 'Dengan melanjutkan sebagai tamu, Anda menyetujui Ketentuan, Kebijakan Data, dan Kebijakan Cookie dari situs web ini',
	chakan: 'Tampilkan',
	xuanzeriqi: 'Pilih Tanggal',
	chufariqi: 'Tanggal Keberangkatan',
	huichengriqi: 'Tanggal Kepulangan',
	chongshe: 'Atur Ulang',
	queren: 'Konfirmasi',
	genggairiqi: 'Rubah Tanggal',
	hangban: 'Penerbangan',
	yingfuzonge: 'Total Jumlah yang harus dibayar',
	genggai: 'Perubahan',
	xianyoufujai: 'Tambahkan yang sudah ada',
	xinhangban: 'Penerbangan Baru',
	zhifu: 'Bayar',
	zuoweiyiyuding: 'Mohon maaf, kursi ini sudah dipilih. Silahkan pilih kursi lain',
	tianjiadaoyuding: 'Tambahkan ke pemesanan',
	ewaituibukongjian: 'Ekstra ruang kursi, baris 10 kursi C',
	xinyongka: 'Kartu',
	denglushiyongfacebook: 'Masuk dengan Facebook',
	jiazaizhong: 'Sedang Memuat',
	denglushibai: 'Gagal masuk',
	zhuceshibai: 'Registrasi Gagal',
	liru: 'Contoh',
	dengluchenggong: 'Login berhasil',
};
